import React from "react";
import SafeIcon from "../../../common/SafeIcon";
import * as FiIcons from "react-icons/fi";

const { FiCalendar, FiRotateCcw, FiSearch } = FiIcons;

export default function ClientExpensesFilters({
  search,
  categoryId,
  vendor,
  startDate,
  endDate,
  sortBy,
  categories,
  vendors,
  onChange,
  onReset,
}) {
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-[minmax(200px,1fr)_180px_180px_160px_160px_160px_auto] xl:items-end">
        <label>
          <span className="mb-1.5 block text-xs font-semibold text-slate-600">Search expenses</span>
          <span className="flex items-center gap-2 rounded-xl border border-slate-200 px-3 py-2.5">
            <SafeIcon icon={FiSearch} className="text-slate-400" />
            <input
              value={search}
              onChange={(event) => onChange("search", event.target.value)}
              placeholder="Description or payee"
              className="min-w-0 flex-1 bg-transparent text-sm outline-none"
            />
          </span>
        </label>
        <label>
          <span className="mb-1.5 block text-xs font-semibold text-slate-600">Category</span>
          <select value={categoryId} onChange={(event) => onChange("categoryId", event.target.value)} className="w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm">
            <option value="all">All categories</option>
            {categories.map((account) => <option key={account.id} value={account.id}>{account.code ? `${account.code} · ` : ""}{account.name}</option>)}
          </select>
        </label>
        <label>
          <span className="mb-1.5 block text-xs font-semibold text-slate-600">Vendor / Payee</span>
          <select value={vendor} onChange={(event) => onChange("vendor", event.target.value)} className="w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm">
            <option value="all">All vendors</option>
            {vendors.map((name) => <option key={name} value={name}>{name}</option>)}
          </select>
        </label>
        {[
          ["startDate", "Date from", startDate],
          ["endDate", "Date to", endDate],
        ].map(([field, label, value]) => (
          <label key={field}>
            <span className="mb-1.5 block text-xs font-semibold text-slate-600">{label}</span>
            <span className="flex items-center gap-2 rounded-xl border border-slate-200 px-3 py-2">
              <SafeIcon icon={FiCalendar} className="text-slate-400" />
              <input type="date" value={value} onChange={(event) => onChange(field, event.target.value)} className="w-full min-w-0 bg-transparent text-sm" />
            </span>
          </label>
        ))}
        <label>
          <span className="mb-1.5 block text-xs font-semibold text-slate-600">Sort by</span>
          <select value={sortBy} onChange={(event) => onChange("sortBy", event.target.value)} className="w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm">
            <option value="newest">Newest first</option>
            <option value="oldest">Oldest first</option>
            <option value="amount">Amount</option>
          </select>
        </label>
        <button type="button" onClick={onReset} className="inline-flex h-[42px] items-center justify-center gap-2 rounded-xl border border-slate-200 px-3 text-xs font-semibold text-slate-600">
          <SafeIcon icon={FiRotateCcw} /> Reset
        </button>
      </div>
      {startDate && endDate && startDate > endDate && <p role="alert" className="mt-3 text-xs font-medium text-rose-700">The start date must be on or before the end date.</p>}
    </section>
  );
}